import styled from 'styled-components';

export const FormTitleWrapper = styled.div`
  padding: 20px 0 24px 0;
  font-weight: 600;
  font-size: 16px;
  color: var(--FORM-LABEL-default);
  border-bottom: 1px solid #d2d3d4;
  font-family: 'inter-semibold', sans-serif;
`;
export const FormNoticeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0 24px 0;
  border-bottom: 1px solid #d2d3d4;
  font-family: 'inter-semibold', sans-serif;
`;
export const Notice = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: var(--FORM-LABEL-default);
  font-family: 'inter-regular', sans-serif;
`;
export const FormTextWrapper = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: var(--FORM-LABEL-default);
  font-family: 'inter-regular', sans-serif;
`;
export const GroupFormDate = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #656464;
`;
export const FormDate = styled.div`
  font-family: 'inter-regular', sans-serif;
  font-weight: 400;
  font-size: 14px;
`;
